import Component from "./Component";
class DuplicatableComponent extends Component {
    constructor(componentResponse) {
        super(componentResponse);
        this.source_client_id = componentResponse.source_client_id;
    }
}
export default DuplicatableComponent;
